import { ScrollView, ScrollViewProps } from '@shared/components/View';
import styles from './MenuScrollable.module.css';

/**
 * Menu.Scrollable
 *
 * A scrollable wrapper for menu content, built on ScrollView. Pass
 * `showScrollIndicators` to display fade masks at the top and bottom when the
 * list overflows.
 */

type MenuScrollableProps = ScrollViewProps;

export function MenuScrollable({
  className,
  showScrollIndicators = false,
  ...rest
}: MenuScrollableProps) {
  return (
    <ScrollView
      className={[
        styles.scrollable,
        showScrollIndicators && styles.showScrollIndicators,
        className,
      ]}
      showScrollIndicators={showScrollIndicators}
      {...rest}
    />
  );
}
